"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gallery = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _base = require("@mui/base");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _paulCorePackage = require("paul-core-package");
var _ImgSwiper = require("./ImgSwiper");
var _FullScreenBtn = require("./FullScreenBtn");
var _hooks = require("../../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Gallery = _ref => {
  let {
    equipmentId,
    withFillScreen = true,
    defaultImg
  } = _ref;
  const [fullScreen, setFullScreen] = (0, _react.useState)(false);
  const [showOnHover, setShowOnHover] = (0, _react.useState)(false);
  const {
    hasimages = [],
    type
  } = (0, _hooks.useGetComponentById)({
    id: equipmentId
  }) || {};
  const handleClose = () => {
    setFullScreen(false);
  };
  const imgSizeKey = _paulCorePackage.constants.imgSizeKeys.original;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      position: 'relative',
      height: '100%',
      width: '100%'
    },
    onMouseOver: () => setShowOnHover(true),
    onMouseOut: () => setShowOnHover(false)
  }, withFillScreen && hasimages.length ? /*#__PURE__*/_react.default.createElement(_FullScreenBtn.FullScreenBtn, {
    fullScreen: fullScreen,
    setFullScreen: setFullScreen,
    opacity: showOnHover ? 1 : 0
  }) : null, /*#__PURE__*/_react.default.createElement(_ImgSwiper.ImgSwiper, {
    type: type,
    imgSizeKey: imgSizeKey,
    imgList: hasimages,
    defaultImg: defaultImg
  }), /*#__PURE__*/_react.default.createElement(_base.Modal, {
    open: fullScreen,
    onClose: handleClose
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      position: 'fixed',
      right: 0,
      bottom: 0,
      top: 0,
      left: 0,
      zIndex: 1300,
      height: '100vh',
      width: '100vw',
      pointerEvents: 'none',
      '& > *': {
        pointerEvents: 'auto'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_FullScreenBtn.FullScreenBtn, {
    fullScreen: fullScreen,
    setFullScreen: setFullScreen,
    inFullScreen: true
  }), /*#__PURE__*/_react.default.createElement(_ImgSwiper.ImgSwiper, {
    fullScreen: fullScreen,
    imgSizeKey: imgSizeKey,
    imgList: hasimages,
    type: type,
    defaultImg: defaultImg
  }))));
};
exports.Gallery = Gallery;
Gallery.propTypes = {
  equipmentId: _propTypes.default.string.isRequired,
  withFillScreen: _propTypes.default.bool,
  defaultImg: _propTypes.default.string
};
Gallery.defaultPropTypes = {
  withFillScreen: true
};